import { RouteObject } from "react-router-dom";
import { DevelopmentCommitmentPage } from "src/routes/development-commitments/DevelopmentCommitmentPage";
import { DevelopmentCommitmentsPage } from "src/routes/development-commitments/DevelopmentCommitmentsPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as commitmentsPaths from "src/routing/domains/developments/commitments/commitmentsPaths";

/**
 * `/development-commitments/*` route trees.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 */
export const commitmentsRoutes: RouteObject[] = [
  {
    path: commitmentsPaths.developmentCommitmentsRoute.path,
    Component: AppShell,
    children: [
      {
        Component: GlobalNavLayout,
        children: [
          {
            Component: ScrollableParentLayout,
            children: [
              { index: true, Component: DevelopmentCommitmentsPage },
              { path: commitmentsPaths.developmentCommitmentRoute.path, Component: DevelopmentCommitmentPage },
            ],
          },
        ],
      },
    ],
  },
];
